import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { DateTimeService } from 'src/app/shared/datetime/datetime.service';
import { LoadingPanelService, LoadingPanelSettings } from '../../../shared/loading-panel/loading-panel.service';
import { SchedulerTaskService } from '../../services/scheduler-task.service';
import { SchedulerLog } from '../../models/scheduler-log';
import { SvgIconComponent } from '../../../shared/icons/svg-icon.component';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../../../shared/grid/biz-grid.directive';
import { DxiColumnModule, DxoFormatModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';

import { SchedulerLogDetailsComponent } from '../scheduler-log-details/scheduler-log-details.component';

@Component({
    selector: 'ep-scheduler-log',
    templateUrl: './scheduler-log.component.html',
    styleUrls: ['./scheduler-log.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, DxDataGridModule, BizDataGridDirective, DxiColumnModule, DxoFormatModule, DxTemplateModule, SchedulerLogDetailsComponent]
})
export class SchedulerLogComponent implements OnInit {
    schedulerTaskId: number;
    getSchedulerLogs$: Observable<SchedulerLog[]>;
    loggedSchedules: SchedulerLog[] = [];
    dateFormat: (date: Date) => string;

    constructor(
        private route: ActivatedRoute,
        private schedulerTaskService: SchedulerTaskService,
        private dateTimeService: DateTimeService,
        private loadingPanelService: LoadingPanelService
    ) {
        this.dateFormat = this.dateTimeService.getDevExpressDateTimeWithMsFunction;
    }

    ngOnInit(): void {
        this.route.paramMap.subscribe(paramMap => {
            this.schedulerTaskId = +paramMap.get('schedulerTaskId');
            this.getSchedulerLogs$ = this.schedulerTaskService.GetLoggedSchedulers(this.schedulerTaskId);
            this.refresh();
        });
    }
    
    refresh(): void {
        this.loadingPanelService.showLoadingPanel(new LoadingPanelSettings('Initialize data...'));        
        
        this.getSchedulerLogs$.subscribe(result => { 
            this.loggedSchedules = result;            
            this.loadingPanelService.hideLoadingPanel();        
        });

    }
}
